module.exports = __webpack_public_path__ + "img/left-static-desktop.be0ee0e.png";